import { get, getTrackingString } from '../../utils/object-helpers';
import storeEvent from '../../utils/store-event';

export default class {
    onInput(input) {
        this.isSmall = get(input, 'page.isSmall', false);
        const info = get(input, 'page.modules.PRESENCE_INFORMATION_MODULE', null);
        const editProfile = get(info, 'editProfileAction', null);
        const cancelEdit = get(info, 'cancelEditProfileAction', null);
        const saveProfile = get(info, 'saveProfileAction', null);
        const model = {
            isSmall: this.isSmall,
            profileEditState: get(input, 'globalState.profileEdit', {}),
            mobileView: input.mobileView
        };

        if (editProfile) {
            model.edit = {
                action: editProfile.action,
                tracking: getTrackingString(editProfile, 'action.trackingList'),
                text: get(editProfile, 'text', ''),
                priority: get(editProfile, 'type', 'SECONDARY').toLowerCase()
            };
        }
        if (cancelEdit) {
            model.cancel = {
                action: cancelEdit.action,
                tracking: getTrackingString(cancelEdit, 'action.trackingList'),
                text: get(cancelEdit, 'text', ''),
                priority: get(cancelEdit, 'type', 'SECONDARY').toLowerCase()
            };
        }
        if (saveProfile) {
            model.save = {
                action: saveProfile.action,
                tracking: getTrackingString(saveProfile, 'action.trackingList'),
                text: get(saveProfile, 'text', ''),
                priority: get(saveProfile, 'type', 'PRIMARY').toLowerCase()
            };
        }

        return model;
    }
    presenceEditAction(action) {
        storeEvent.presenceEdit.dispatch({ action });
    }
}
